import { apiFetch } from 'zn-common'
import { postForm } from '@src/common'

/**
 * 请求登录
 * @param params
 */
export const getLogin = async (params = {}): Promise<any> => {
  try {
    const result = await postForm('/open/znClientapi/index.do', params, { dataType: '*' })
    // 后台重定向到首页，判断是html
    if (result.includes('html')) {
      return { code: 200, msg: '登录成功' }
    }
    const { code, msg, message, data } = JSON.parse(result.replace(/'/g, '"'))
    return { code, data, msg: (message || msg) } // 登录接口统一message字段
  } catch (e) {
    return { code: '-1', msg: '获取数据失败' }
  }
}
/**
 * 请求登录
 * @param params
 */
export const getQrCodeInfo = async (params = {}): Promise<any> => apiFetch({ url: 'qrCode/login/getQrCodeInfo.do' }, { data: params })
